import * as fallbackImage from '../../images/default-fallback-image.png';
import getImageUrl, { getFeaturedImage } from '../util/getImage'
export default class {

  constructor() {
    this.page = 1
    this.perPage = 5;
    this.restaurantId = null;
    this.init(),
    this.events();
  }

  init() {
    const $wrapper = $('.js-restaurantRooms')
    if ( !$wrapper.length ) return
    this.restaurantId = $wrapper.attr('data-restaurant')
  }

  getData() {
    const that = this
    const $wrapper = $('.js-restaurantRooms__cards')
    const $pagination = $('.js-restaurantRooms__pagination')
    const $currentPagePlaceholder = $('.js-restaurantRooms__currentPage')
    const $lastPagePlaceholder = $('.js-restaurantRooms__lastPage')
    const $nextPageButton = $('.js-restaurantRooms__paginationButton--next')

    // eslint-disable-next-line
    let url = `${API_BASE_URL}/venues/${this.restaurantId}/rooms?`

    const params = {}
    if ( this.perPage ) {
      params['per_page'] = this.perPage
    }
    if ( this.page > 1 ) {
      params['page'] = this.page
    }
    if ( Object.keys(params) ) {
      url += $.param(params)
    }

    $wrapper.addClass('is-loading')
    $wrapper.append('<div class="l-spinner"><div class="l-spinner__el"></div></div>')

    $pagination.addClass('is-loading')

    $.get( url, function( response ) {

      console.log(response)
      if ( response.data.length ) {

          const markup = that.getMarkup( response.data )

          const $spinner = $('.l-spinner')
          if ( $spinner.length ) {
            $spinner.remove()
          }

          $wrapper.html(markup)

          $currentPagePlaceholder.text(response.current_page)
          $lastPagePlaceholder.text(response.last_page)
          $nextPageButton.attr('data-last-page', response.last_page)

          $wrapper.removeClass('is-loading')
          $pagination.removeClass('is-loading')
      
      } else {
        const noDataMarkup = `
          <div class="col-12 d-flex align-items-center justify-content-center mt-4">
            <p><strong>No rooms</strong></p>
          </div>
        `
        $wrapper.html(noDataMarkup)
      }
    });
  }

  getMarkup(rooms) {
    if ( !rooms.length ) return

    let content = ''

    rooms.map( room => {
      const image = getImageUrl(getFeaturedImage(room.images), 'default', '559x327' )
      content += `
        <div class="c-restaurantRoomCard">
          <div class="c-restaurantRoomCard__imageWrapper">
            <div class="h-objectImage h-objectImage--3by2 visible js-objectImage">
              ${
                image ? (
                  ` 
                    <img class="l-card__image" src="${ image ? image : ''}" alt="${room['title']}">
                  `
                ) : (
                  `<img class="l-card__image" src="${fallbackImage}">`
                )
              }
            </div>
          </div>
          <div class="c-restaurantRoomCard__body l-box d-flex flex-column justify-content-center">
            <h3 class="c-restaurantRoomCard__title">${room['name'] ? room['name'] : ''}</h3>
            <div class="c-restaurantRoomCard__description">${room['description'] ? room['description'] : '' }</div>
            <div class="c-restaurantRoomCard__info d-flex flex-wrap align-items-center">
              ${ 
                ( room['min_capacity'] && room['max_capacity'] )  && (
                  `<div class="c-restaurantRoomCard__infoDetail">
                    <p class="h-fontChronicle m-0">Capacities</p>
                  </div>`
                )
              }
              ${
                room['min_capacity'] && (
                  `
                  <div class="c-restaurantRoomCard__infoDetail">
                    <span>Minimum</span>
                    <span>${room['min_capacity']}</span>
                  </div>
                  `
                )
              }
              ${
                room['max_capacity'] && (
                  `
                  <div class="c-restaurantRoomCard__infoDetail">
                    <span>Maximum</span>
                    <span>${room['max_capacity'] }</span>
                  </div>
                  `
                )
              }
            </div>
          </div>
        </div>
      `
    })
    return content
  }

  events() { 
    $('.js-restaurantRooms__paginationButton').on('click', (e) => {
      const $this = $(e.currentTarget)
      e.preventDefault()
      if ( $this.hasClass('c-restaurantRooms__paginationButton--prev') ) { 
        this.page--
      }  else if ( $this.hasClass('c-restaurantRooms__paginationButton--next') ) {
        if ( ( this.page + 1 ) > parseFloat( $this.attr('last-page') ) ) {
          return
        }
        this.page++
      }
      this.getData()
    })

    $('.js-restaurantRooms__dropdown').on('change', (e) => {

      const $this = $(e.target)
      const value = e.target.value

      if ( $this.hasClass('c-restaurantRooms__dropdown--perPage') ) {
        this.perPage = value
        this.page = 1
        this.getData()
      }
    })

  }

}